import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';
import enJSON from './translations/en';
import frJSON from './translations/fr';

import { enumLanguage } from '../types/enumeration';
import {
  getLanguagePreference,
  setLanguagePreference
} from '../preferences/preferences';

const resources = {
  en: { translation: enJSON },
  fr: { translation: frJSON }
};

const SUPPORTED_LANGUAGES: Array<string> = Object.values(enumLanguage);

// English by default: another language is only ever shown once chosen in the user menu
const getInitialLanguage = (): string => {
  const preferred = getLanguagePreference();
  let result: string = enumLanguage.en;

  if (preferred && SUPPORTED_LANGUAGES.includes(preferred)) {
    result = preferred;
  }

  return result;
};

export const changeLanguage = (language: string) => {
  setLanguagePreference(language);
  return i18n.changeLanguage(language);
};

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language;
});

i18n.use(initReactI18next).init({
  resources,
  lng: getInitialLanguage(),
  keySeparator: false,
  fallbackLng: enumLanguage.fr,
  react: {
    useSuspense: true
  },
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
